import {
  GetterTree,
} from 'vuex';

import {
  AuthState,
} from '@/store/modules/auth/types';
import {
  RootState,
} from '@/store/types';

export const getters: GetterTree<AuthState, RootState> = {
  isAuthenticated: (state: AuthState): boolean => state.isAuthenticated,
};
